import React from "react";
import NavigationBarLogo from "./Nav-Details/NavigationBarLogo";
import NavigationBarNavLink from "./Nav-Details/NavigationBarNavLink";
export default function RegularNavigationBar({
  handleContentChange,
  userProfile,
}) {
  return (
    <div className="d-flex justify-content-between pr-3">
      <NavigationBarLogo />
      <NavigationBarNavLink
        handleContentChange={handleContentChange}
        userProfile={userProfile}
      />
    </div>
  );
}
